// src/components/common/LoadingComponent.js
import React from 'react';
import { Spin, Space, Row, Col } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

function LoadingComponent() {
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  return (
    <Row justify="center" align="middle" style={{ minHeight: '80vh' }}>
      <Col>
        <Space direction="vertical" size="middle" align="center">
          <Spin indicator={antIcon} size="large" />
          <div>Loading content...</div>
        </Space>
      </Col>
    </Row>
  );
}

export default LoadingComponent;
